var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "formula-generator" }, [
    !_vm.aiResult
      ? _c(
          "div",
          { staticClass: "prompt-container" },
          [
            _c("p", [
              _vm._v(
                "Supsis Asistan'a ne tür bir formül oluşturmak istediğinizi anlatın."
              ),
            ]),
            _vm._v(" "),
            _c("s2-textarea", {
              ref: "promptTextarea",
              attrs: {
                rows: 4,
                placeholder:
                  "Örnek: Fiyat ve miktar alanlarını çarpıp KDV ekleyerek toplam tutarı hesapla...",
              },
              model: {
                value: _vm.customerPrompt,
                callback: function ($$v) {
                  _vm.customerPrompt = $$v
                },
                expression: "customerPrompt",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "assistant-buttons" },
              [
                _c(
                  "a-button",
                  {
                    attrs: {
                      type: "primary",
                      loading: _vm.aiLoading,
                      disabled: !_vm.customerPrompt,
                    },
                    on: { click: _vm.generateFormula },
                  },
                  [_vm._v("\n                Formül Oluştur\n            ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "example-prompts" }, [
              _c("h4", [_vm._v("Örnek İstekler:")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "prompt-cards" },
                _vm._l(_vm.examplePrompts, function (prompt, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "prompt-card",
                      on: {
                        click: function ($event) {
                          _vm.customerPrompt = prompt
                        },
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "bulb" } }),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(prompt))]),
                    ],
                    1
                  )
                }),
                0
              ),
            ]),
          ],
          1
        )
      : _c("div", { staticClass: "result-container" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "result-formula" }, [
            _c("pre", [_vm._v(_vm._s(_vm.aiResult.formula))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "result-explanation" }, [
            _c("p", [_vm._v(_vm._s(_vm.aiResult.explanation))]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "result-buttons" },
            [
              _c(
                "a-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.useGeneratedFormula },
                },
                [_vm._v("Bu Formülü Kullan")]
              ),
              _vm._v(" "),
              _c("a-button", { on: { click: _vm.resetAiAssistant } }, [
                _vm._v("Yeni Formül Oluştur"),
              ]),
            ],
            1
          ),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "result-header" }, [
      _c("h3", [_vm._v("Oluşturulan Formül")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }